import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import html2canvas from "html2canvas";
import html2pdf from "html2pdf.js";
import jsPDF from "jspdf";

import SalesUserSideMenu from "../../../menu/SalesUserSideMenu";
import Header from "../common/AuthHeader";
import { ANY_ERROR } from "../../../action/user_action_types";
import { fileUrl } from "../../../config";
import { history } from "../../../history/history";
import { GetPdfHtml } from "../../common/CampaignPdfHtml";
import ReactAudioPlayer from "react-audio-player";
import { calculateAmountAndTax } from "../../../util/util";

class ViewCampaign extends Component {
  constructor(props) {
    super(props);
    this.state = {
      campaignData: {},
    };
  }

  //Set Campaign Data to state
  componentWillMount = () => {
    let { campaignData } = this.props.location.state;
    campaignData = calculateAmountAndTax(campaignData)
    this.setState({ campaignData });
  };

  goToRoute = (route) => {
    history.push(route);
  };

  //Generating the pdf
  generatePdf = async () => {
    let { campaignData } = this.state;
    const input = document.getElementById("divToPrint");
    input.style.display = "block";
    var opt = {
      filename: `${campaignData._id}.pdf`,
    };
    await html2pdf()
      .from(input)
      .set(opt)
      .save();
    input.style.display = "none";
  };

  //Show campaign info
  render() {
    let { campaignData } = this.state;
    return (
      <div className="main_wrapper view_detail">
        <SalesUserSideMenu {...this.props} />
        <div className="dashboard_right_wrapper">
          <div className="right_wrapper_inner">
            <Header />
            <div className="dash_content_wrapper">
              <div className="content_wrapper_inner">
                <div className="container-head print_head">
                  <div className="campdashboard-breadcrumb">
                    Campaign Management &gt;{" "}
                    <span className="campdeatil_head">Campaign Detail</span>
                  </div>
                  <div className="print_btn">
                    <button onClick={this.generatePdf}>
                      Download Campaign details
                    </button>
                  </div>
                </div>
                <div className="campviewlist_detail_wrapper">
                  <div className="campviewlist_detail_left">
                    <h2 className="campview-detail_header">Campaign Detail</h2>
                    <div className="campviewlist_left_inner">
                      <div className="campviewlist_data">
                        <span className="campviewlist_head">Campaign Name</span>
                        <span className="campviewlist_name">
                          {campaignData.name}
                        </span>
                      </div>
                      <div className="campviewlist_data">
                        <span className="campviewlist_head">Brand Name</span>
                        <span className="campviewlist_name">
                          {campaignData.brand}
                        </span>
                      </div>
                      <div className="campviewlist_data">
                        <span className="campviewlist_head">
                          Product Category
                        </span>
                        <span className="campviewlist_name">
                          {campaignData.product}
                        </span>
                      </div>
                    </div>
                    <div className="campviewlist_left_inner">
                      <div className="campviewlist_data">
                        <span className="campviewlist_head">Package Type</span>
                        <span className="campviewlist_name">
                          {campaignData.type}
                        </span>
                      </div>
                      <div className="campviewlist_data">
                        <span className="campviewlist_head">Days Count</span>
                        <span className="campviewlist_name">
                          {campaignData.days}
                        </span>
                      </div>
                      <div className="campviewlist_data">
                        <span className="campviewlist_head">Start Date</span>
                        <span className="campviewlist_name">
                          {moment(campaignData.startDate).format("DD/MM/YYYY")}
                        </span>
                      </div>
                    </div>
                    {campaignData.bookingType && 
                    <div className="campviewlist_left_inner">
                      <div className="campviewlist_data">
                        <span className="campviewlist_head">Time Band</span>
                        <span className="campviewlist_name" style={{textTransform:"capitalize"}}>
                          {campaignData.bookingType}
                        </span>
                      </div>
                      {campaignData.timebands && (
                        <div className="campviewlist_data">
                          <span className="campviewlist_head">
                            Selected Bands
                          </span>
                          <span className="campviewlist_name">
                            {campaignData.timebands}
                          </span>
                        </div>
                      )}
                    </div>}
                    <div className="campviewlist_left_inner">
                      <div className="campviewlist_data">
                        <span className="campviewlist_head">
                          What is the objective of your campaign ?
                        </span>
                        <span className="campviewlist_name">
                          {campaignData.objective}
                        </span>
                      </div>
                      <div className="campviewlist_data">
                        <span className="campviewlist_head"></span>
                        <span className="campviewlist_name"></span>
                      </div>
                      <div className="campviewlist_data">
                        <span className="campviewlist_head">Campaign ID</span>
                        <span className="campviewlist_name">
                          {campaignData._id}
                        </span>
                      </div>
                    </div>
                    {campaignData.audioUrl && !campaignData.audioUrls && (
                      <div className="campviewlist_left_inner">
                        <div className="campviewlist_data">
                          <span className="campviewlist_head">
                            Uploaded Audio File
                          </span>
                          <div className="campviewlist_name">
                            <div className="audio_inner">
                              <div className="viewaudio_img">
                                <img src="../../assets/images/song.svg" />
                              </div>
                              <div className="file_desc">
                                <div className="file_name_size">
                                  <div className="file_name">
                                    {campaignData.fileName}
                                  </div>
                                  <span className="file_size">
                                    Audio length : {campaignData.audioLength}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="campviewlist_data">
                          <div className="campviewlist_left_audio_player">
                            <ReactAudioPlayer
                              src={campaignData.audioUrl}
                              controls
                              controlsList="nodownload"
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    {campaignData.audioUrls &&
                      campaignData.audioUrls.length > 0 && (
                        <div className="campviewlist_left_inner">
                          <div className="campviewlist_head">
                            Uploaded Audio Files
                          </div>
                        </div>
                      )}
                    {campaignData.audioUrls &&
                      campaignData.audioUrls.length > 0 &&
                      campaignData.audioUrls.map((audio) => {
                        return (
                          <React.Fragment>
                            <div className="campviewlist_left_inner">
                              <div className="campviewlist_data">
                                <div className="campviewlist_name">
                                  <div className="audio_inner">
                                    <div className="viewaudio_img">
                                      <img src="../../../assets/images/song.svg" />
                                    </div>{" "}
                                    <div className="file_desc">
                                      <div className="file_name_size">
                                        <div className="file_name">
                                          {" "}
                                          {audio
                                            ? audio.name
                                            : campaignData.fileName}{" "}
                                        </div>{" "}
                                        <span className="file_size">
                                          Audio length :{" "}
                                          {campaignData.audioDuration.toFixed(
                                            0
                                          )}{" "}
                                          sec
                                        </span>
                                      </div>{" "}
                                    </div>{" "}
                                  </div>{" "}
                                </div>{" "}
                              </div>{" "}
                              <div className="campviewlist_data">
                                <div className="campviewlist_left_audio_player">
                                  <ReactAudioPlayer
                                    src={audio.awsurl}
                                    controls
                                    controlsList="nodownload"
                                  />
                                </div>{" "}
                                <div> </div>{" "}
                              </div>{" "}
                            </div>
                          </React.Fragment>
                        );
                      })}
                  </div>
                  <div className="campviewlist_detail_right">
                    <div className="campviewlist_cost_card">
                      <h5>Campaign Cost</h5>
                      <ul className="campviewlist_cost_list">
                        {campaignData.actualpackageCost !== campaignData.packageCost && 
                        <li className="campviewlist_list_inner">
                          <div className="campviewlist_type">Package Cost</div>
                          <div className="campviewlist_rupee_symb">
                            <img src="../../assets/images/rupee-indian.svg" />
                            <span className="cost_inner">
                              {campaignData.actualpackageCost}
                            </span>
                          </div>
                        </li>}
                        <li className="campviewlist_list_inner">
                          <div className="campviewlist_type">Package Cost</div>
                          <div className="campviewlist_rupee_symb">
                            <img src="../../assets/images/rupee-indian.svg" />
                            <span className="cost_inner">
                              {campaignData.packageCost}
                            </span>
                          </div>
                        </li>
                        <li className="campviewlist_list_inner">
                          <div className="campviewlist_type">Taxes@18%</div>
                          <div className="campviewlist_rupee_symb">
                            <img src="../../assets/images/rupee-indian.svg" />
                            <span className="cost_inner">
                              {campaignData.taxes}
                            </span>
                          </div>
                        </li>
                        {campaignData.audioTotalCost > 0 && (
                          <li className="campviewlist_list_inner">
                            <div className="campviewlist_type">Audio Cost</div>
                            <div className="campviewlist_rupee_symb">
                              <img src="../../assets/images/rupee-indian.svg" />
                              <span className="cost_inner">
                                {campaignData.audioTotalCost}
                              </span>
                            </div>
                          </li>
                        )}
                        {campaignData.audioDiscount > 0 && (
                          <li className="campviewlist_list_inner">
                            <div className="campviewlist_type">
                              Audio Discount
                            </div>
                            <div className="campviewlist_rupee_symb">
                              <img src="../../assets/images/rupee-indian.svg" />
                              <span className="cost_inner">
                                {campaignData.audioDiscount}
                              </span>
                            </div>
                          </li>
                        )}
                        {campaignData.couponDiscount > 0 && (
                          <li className="campviewlist_list_inner">
                            <div className="campviewlist_type coupon">
                              Coupon Discount
                              {campaignData.couponPercentage && (
                                <span className="discount_desc">
                                  Coupon Applied Flat $
                                  {campaignData.couponPercentage} % OFF
                                </span>
                              )}
                            </div>
                            <div className="campviewlist_rupee_symb">
                              <img src="../../assets/images/rupee-indian.svg" />
                              <span className="cost_inner">
                                {campaignData.couponDiscount}
                              </span>
                            </div>
                          </li>
                        )}
                        <div className="totalcost">
                          <div className="campviewlist_type">Total Cost</div>
                          <div className="campviewlist_rupee_symb">
                            <img src="../../assets/images/rupee-indian_white.svg" />
                            <span className="cost_inner">
                              {campaignData.totalCost}
                            </span>
                          </div>
                        </div>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="detail_wrapper">
                  <div className="package_wrapper">
                    <div className="package_includes_wrapper">
                      {campaignData.fctperDay > 0 &&
                        campaignData.secondages > 0 &&
                        campaignData.additionalBenefits &&
                        campaignData.packageDiscountedCost && (
                          <div>
                            <h3>Package Includes :</h3>
                            <p>
                              {campaignData.fctperDay} Seconds Per Day I{" "}
                              {campaignData.secondages} Total Secondages I Total
                              Cost: {campaignData.totalCost} INR I Additional
                              Benefit: {campaignData.additionalBenefits} % I
                              Discounted Cost:{" "}
                              {campaignData.packageDiscountedCost} INR
                            </p>
                          </div>
                        )}
                      {campaignData.secondages > 0 &&
                        campaignData.additionalBenefits &&
                        campaignData.packageDiscountedCost && (
                          <div>
                            <h3>Package Includes :</h3>
                            <p>
                              {campaignData.secondages} Total Secondages I Total
                              Cost: {campaignData.totalCost} INR I Additional
                              Benefit: {campaignData.additionalBenefits} % I
                              Discounted Cost:{" "}
                              {campaignData.packageDiscountedCost} INR
                            </p>
                          </div>
                        )}
                    </div>
                    <div className="view-btn_wrapper">
                      <button
                        className="viewdetail_back"
                        onClick={() => this.goToRoute("/tp/campaign")}
                      >
                        BACK
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <GetPdfHtml campaign={campaignData} />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showError: (error) =>
      dispatch({
        type: ANY_ERROR,
        payload: error,
      }),
  };
};

export default connect(null, mapDispatchToProps)(ViewCampaign);



// WEBPACK FOOTER //
// ./web/components/salesUser/campaign/ViewCampaign.jsx